<template>
	<div class="order-search-body">
		<div class="storage-search">
			<div class="filters-box-row">
				<div class="filters-container">
					<div class="input-box">
						<span>编号：</span>
						<el-input
							class="search-input"
							v-model="searchCode"
							placeholder="请输入商品/规格编号/条形码/关联"
							size="small"
							@keyup.enter.native="search">
						</el-input>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<span>名称：</span>
						<el-input
							class="search-input"
							v-model="searchName"
							placeholder="请输入商品名称/规格名称"
							size="small"
							@keyup.enter.native="search">
						</el-input>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<span>类型：</span>
						<el-select v-model="stockType" style="width:90px" size='small'>
							<el-option :value="-1" label="全部"></el-option>
							<el-option :value="0" label="入库"></el-option>
							<el-option :value="1" label="出库"></el-option>
						</el-select> --
						<el-input
							class="search-input"
							v-model="stockTypeName"
							placeholder="请输入类型"
							size="small"
							@keyup.enter.native="search">
						</el-input>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<span>对方：</span>
						<el-input
							class="search-input"
							v-model="theOtherName"
							placeholder="请输入对方名称"
							size="small"
							@keyup.enter.native="search">
						</el-input>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<span>附件：</span>
						<el-select v-model="hasDocument" class="filter-input" size='small'>
							<el-option :value="-1" label="全部"></el-option>
							<el-option :value="0" label="无"></el-option>
							<el-option :value="1" label="有"></el-option>
						</el-select>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<span>备注：</span>
						<el-input
							class="search-input"
							v-model="memo"
							placeholder="请输入备注"
							size="small"
							@keyup.enter.native="search">
						</el-input>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<span>日期：</span>
						<div class="time-box">
							<div :class="searchDateType === 1 ? 'selected' : ''" @click="changeTime(1)">本年</div>
							<div :class="searchDateType === 2 ? 'selected' : ''" @click="changeTime(2)">本月</div>
							<div :class="searchDateType === 3 ? 'selected' : ''" @click="changeTime(3)">本周</div>
							<div :class="searchDateType === 4 ? 'selected' : ''" @click="changeTime(4)">今日</div>
							<div class="time-diy" :class="searchDateType === 5 ? 'selected' : ''">{{timeDiy}}<i class="el-icon-caret-bottom"></i>
								<el-date-picker
									@change="searchTime"
									v-model="dateValue"
									:clearable="false"
									:unlink-panels='true'
									class="time-input"
									size="small"
									type="datetimerange"
									range-separator="至"
									start-placeholder="开始日期"
									end-placeholder="结束日期"
									format='yyyy-MM-dd'
									value-format='yyyy-MM-dd'>
								</el-date-picker>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="storage-box-btn">
				<!-- <el-button size="small" type="text" class="btn" style="color:#333;margin-left:10px" @click="handleCollapse">
					{{ collapse ? '展开' : '收起' }}
					<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" style="color:#AFB1B3;"/>
				</el-button> -->
				<el-button size="small" type="primary" class="btn fx-btn" @click="search">查询</el-button>
				<el-button size="small" plain class="btn fx-btn" style="margin-left: 10px" @click="clear">清空</el-button>
			</div>
		</div>
		<div class="filters-box-row filters-box-row2">
			<div class="filters-container" v-show="!collapse">
			</div>
		</div>
		<div class="filters-box-row filters-box-row3">
			<el-button size="small" type="primary" plain class="btn fx-btn" style="margin-left: 0px;width:75px" v-if="AuthorityList['13_0001_0002_00']" @click="addStorage()">新建</el-button>
			<!-- <el-button size="small" type="primary" plain class="btn fx-btn" v-if="AuthorityList['11_0002_0003_00']" @click="liquidate(0)">取消勾销</el-button> -->
			<el-button size="small" type="primary" plain class="btn fx-btn export-btn" style="margin-left: 10px" @click="importFile">
				<div></div>
				导入
			</el-button>
			<el-button size="small" type="primary" plain class="btn fx-btn export-btn" style="margin-left: 10px" @click="exportExcel">
				<div></div>
				导出
			</el-button>
			<input type="file" ref="file" id="file" accept=".xls,.xlsx" v-show="false" @change="getFile">
			<span class="batch-register-btn" @click="downloadFile">
				<i class="excel-icon export-excel-icon"/>
				<span>导入模板下载</span>
			</span>
			<a :href="downloadUrl" ref="download" v-show="false"></a>
			<div class="progress-box" v-if="percentShow">
				<span class="progress-title">当前刷新进度:</span><el-progress :stroke-width="8" :percentage="percentNum" style="width:200px"></el-progress> 预计剩余{{percentSecond}}
			</div>
		</div>
		<el-dialog title="提示" class="confirm-dialog" top='60px' :visible.sync="errorMsgModel" width='400px' :close-on-click-modal="false">
			<div style="margin-bottom:10rpx;max-height:250px;overflow:auto">
				<div class="errormsgText" v-for="(item,index) in errorMsgList" :key='index' >
					{{item}}
				</div>
			</div>
			<div style="width:100%;text-align: center;margin-top:10px">
				<el-button size="small" style="width: 120px;" plain type="primary" @click="errorMsgClick">确认</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'search',
	props: {
		ids: {
			type: Array,
			default: () => []
		},
		rpasId: {
			type: Array,
			default: () => []
		},
		AuthorityList: {
			type: Object
		}
	},
	data () {
		return {
			collapse: false,
			dateValue: [this.$fxUtils.getCurrentMonthFirst(), this.$fxUtils.getCurrentMonthLast()],
			searchCode: '',
			searchName: '',
			stockType: -1,
			stockTypeName: '',
			hasDocument: -1,
			memo: '',
			theOtherName: '',
			searchDateType: 2,
			timeDiy: '自定义',
			errorMsgModel: false,
			errorMsgList: [],
			downloadUrl: '',
			percentShow: false,
			percentNum: 0,
			percentCount: '',
			percentSecond: '',
			filterArr: ['1278045867575746560', '1284199491759906816', '720926033251270656'],
			filterFlag: false
		}
	},
	created () {
		const syscodeid = window.sessionStorage.getItem('entid')
		this.filterFlag = this.filterArr.includes(syscodeid)
		if (window.sessionStorage.getItem('storageSelect') && !this.filterFlag) {
			let data = JSON.parse(window.sessionStorage.getItem('storageSelect'))
			this.dateValue = data.dateValue
			this.searchCode = data.searchCode
			this.searchDateType = data.searchDateType
			this.searchName = data.searchName
			this.theOtherName = data.theOtherName
			this.stockType = data.stockType
			this.stockTypeName = data.stockTypeName
			this.hasDocument = data.hasDocument
			this.memo = data.memo
			if (this.searchDateType === 5) {
				this.timeDiy = this.dateValue[0] + ' - ' + this.dateValue[1]
			}
		}
	},
	beforeDestroy () {
		clearInterval(this.timer)
		this.timer = null
	},
	watch: {
		rpasId: {
			handler (val) {
				this.percentCount = ''
				this.loop()
			},
			immediate: true
		}
	},
	methods: {
		// 选择日期
		changeTime (value) {
			this.searchDateType = value
			this.dateValue = []
			this.timeDiy = '自定义'
		},
		addStorage () {
			this.$router.push('editStorage')
		},
		// 进度条
		loop () {
			// console.log(this.rpasId)
			this.check()
			clearInterval(this.timer)
			this.timer = setInterval(() => {
				this.check()
			}, 5000)
		},
		check () {
			let params = {
				type: 'stock_refresh_',
				attrplanids: this.rpasId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQNVShop}/stock/inventoryrefresh/progress`,
				data: params,
				loading: false
			}).then(res => {
				if (res.count === 0) {
					clearInterval(this.timer)
					this.percentShow = false
					if (this.percentCount) {
						this.$emit('modifySuc')
					}
					this.percentCount = ''
				} else {
					this.percentShow = true
					if (!this.percentCount) {
						this.percentCount = res.count
						this.percentNum = 0
					} else {
						this.percentNum = +this.$fxUtils.toFixedSHW(((this.percentCount - res.count) / this.percentCount * 100), 2)
					}
					this.percentSecond = res.seconds + '秒'
				}
			})
		},
		searchTime (value) {
			// window.sessionStorage.setItem('afterSearchTime', JSON.stringify(value))
			// console.log(value)
			if (value === null) {
				this.searchDateType = 2
				this.timeDiy = '自定义'
			} else {
				this.searchDateType = 5
				this.timeDiy = value[0] + ' - ' + value[1]
			}
		},
		handleCollapse () {
			this.collapse = !this.collapse
		},
		checkTime () {
			if (this.dateValue === null || this.dateValue.length === 0) {
				this.$message.error('请选择正确时间范围！')
				return false
			}
			var begintime = this.dateValue[0]
			var endtime = this.dateValue[1]
			// 判断时间跨度是否大于12个月
			var arr1 = begintime.split('-')
			var arr2 = endtime.split('-')
			arr1[1] = parseInt(arr1[1])
			arr1[2] = parseInt(arr1[2])
			arr2[1] = parseInt(arr2[1])
			arr2[2] = parseInt(arr2[2])
			var flag = true
			if (arr2[0] - arr1[0] > 1) {
				flag = false
			} else if (arr2[0] - arr1[0] === 1) {
				if (arr1[1] < arr2[1]) { // 月相隔大于12个月
					flag = false
				} else if (arr1[1] === arr2[1]) { // 月相隔12个月，比较日
					if (arr2[2] > arr1[2]) { // 结束日期的日大于开始日期的日
						flag = false
					}
				}
			}
			if (!flag) {
				this.$message.error('时间范围不得超过12个月！')
				return false
			}
			return true
		},
		search () {
			// this.dateValue = this.dateValue === null ? [] : this.dateValue
			// if (this.checkTime()) {
			this.$emit('handleSearch', { searchCode: this.searchCode, searchName: this.searchName, stockType: this.stockType, dateValue: this.dateValue, stockTypeName: this.stockTypeName, theOtherName: this.theOtherName, hasDocument: this.hasDocument, memo: this.memo, searchDateType: this.searchDateType })
			// }
		},
		downloadFile () {
			const that = this
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQNVShop}/stock/importExcel/template/url`
			}).then(res => {
				this.downloadUrl = res.data + '?timestamp=' + new Date().getTime()
				setTimeout(function () {
					that.$refs.download.dispatchEvent(new MouseEvent('click'))
				}, 500)
			})
		},
		// 导入
		importFile () {
			this.$refs.file.dispatchEvent(new MouseEvent('click'))
		},
		getFile () {
			return new Promise((resolve, reject) => {
				var formData = new FormData()
				formData.append('file', this.$refs.file.files[0])
				this.$store.dispatch('requestFilePost', {
					url: `${this.$fxBaseApi.newExportUrl}/stock/importExcel`,
					data: formData
				}).then(res => {
					if (res.result) {
						this.$message.success('导入成功！')
						this.$emit('modifySuc')
					} else {
						this.errorMsgList = res.data
						this.errorMsgModel = true
					}
				})
				this.$refs.file.value = ''
			})
		},
		errorMsgClick () {
			this.errorMsgModel = false
		},
		// 导出
		exportExcel () {
			this.$emit('exportExcel')
		},
		clear () {
			// let value = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59']
			// this.searchTime(value)
			this.clearAllInput()
			this.search()
		},
		clearAllInput () {
			this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59']
			this.timeDiy = '自定义'
			this.searchCode = ''
			this.searchDateType = 2
			this.searchName = ''
			this.theOtherName = ''
			this.stockType = -1
			this.stockTypeName = ''
			this.hasDocument = -1
			this.memo = ''
		}
	}
}
</script>

<style lang="stylus" scoped>
.storage-search {
	display: flex;
	width :100%;
	line-height :50px;
	justify-content: space-between
}
.storage-box-btn{
	width: 150px;
	flex-shrink: 0
}
.filters-box-row {
	display: flex;
	// min-width :600px;
	box-sizing: border-box
	text-align: left
	flex-wrap:wrap;
	.select-input {
		width: 115px!important;
	}
	// &.filters-box-row2 {
// 	padding-top: 0;
	.filters-container {
		display: flex
		flex-wrap: wrap
		.input-box {
			margin-right: 5px;
			display: flex;
			align-items: center;
			.time-box {
				display: flex;
				&>div {
					padding: 0 10px;
					text-align: center;
					height: 24px;
					line-height: 24px;
					border: 1px solid #ebeef5;
					border-radius: 4px;
					margin-right: 5px;
					cursor: pointer
					&.selected {
						color: var(--fx-primary-color);
						border: 1px solid var(--fx-primary-color);
					}
					&.time-diy {
						position: relative;
						padding-right: 5px;
						i {
							margin-left: 5px
						}
						.time-input {
							position: absolute;
							top: 0;
							bottom: 0;
							left: 0;
							right: 0;
							z-index: 9
							opacity: 0
							&.el-date-editor--datetimerange.el-input__inner {
								width: 100%
							}
						}
					}
				}
			}
		}
	}
	// }
	&.filters-box-row3 {
		padding-top: 5px;
		height: 50px
		.progress-box {
			height: 32px
			display: flex
			align-items: center
			.progress-title {
				margin: 0 5px 0 25px
			}
		}
	}
	.filters-container {
		margin-right: 5px
		.el-input {
			width: 230px
		}
		.filter-input {
			width: 230px
		}
		.excel-icon {
			display inline-block
			height 20px
			width 20px
			background-repeat no-repeat
			background-position center
			vertical-align: sub;
			&.import-excel-icon {
				background-image: url('~images/icon/import-excel-icon.png')
			}
			&.export-excel-icon {
				background-image: url('~images/icon/export-excel-icon.png')
			}
		}
	}
	.batch-register-btn{
		cursor :pointer;
		color: var(--fx-primary-color);
		font-size: 12px;
		margin-left: 10px;
		width: 100px;
		height: 32px;
		display: flex;
		align-items: center;
		justify-content: center
	}
	.excel-icon {
		display inline-block
		height 20px
		width 20px
		background-repeat no-repeat
		background-position center
		&.import-excel-icon {
			background-image: url('~images/icon/import-excel-icon.png')
		}
		&.export-excel-icon {
			background-image: url('~images/icon/export-excel-icon.png')
		}
	}
}
</style>
<style lang="stylus">
	.export-btn {
		span {
			display: flex;
			align-items: center
			div {
				width: 14px;
				height: 14px;
				margin-right: 5px;
				background-image: url('~images/icon/export-icon.png')
			}
		}
		&:hover {
			div {
				background-image: url('~images/icon/export-white-icon.png')
			}
		}
	}
	.input-tel input{
		-webkit-appearance: none;
		-webkit-box-sizing: content-box;
		font-family: inherit;
		font-size: 100%;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}
	.confirm-dialog {
		text-align left
		.errormsgText{
			width:100%;
			text-align :left
			line-height:30px;
		}
	}
	.progress-box {
		.el-progress__text {
			font-size: 12px!important
		}
	}
</style>
